import { ClientType, TargetPayloadType } from 'storeTypes'

type ActivePackage = { delivered?: boolean; dropped?: boolean }

export const buildClientUrl = (
    client: Partial<ClientType>,
    orders?: ActivePackage[]
) => {
    const ordersToCheck = orders ?? client?.goal_items ?? []
    const hasActivePackage = ordersToCheck.some(
        (item) => !item.delivered && !item.dropped
    )
    const isPrevious = (client?.all_enrollment || 0) <= 0 && !hasActivePackage
    const clientVillageId = client?.village_id || client?.village

    if (isPrevious) {
        return `/village/${clientVillageId}/client/${client?.client_code}/previous`
    }

    return `/village/${clientVillageId}/client/${client?.client_code}`
}

export const buildTargetListUrl = (targetListData: TargetPayloadType) =>
    `/village/${targetListData.village_id}/client/${
        targetListData.client_code
    }/${targetListData.client_type === 'previous' ? 'previous' : ''}`

export const buildCardSaleUrl = (clientCode?: string, villageId?: string) => {
    return `/cards/card-sale?client-code=${clientCode}&village-id=${villageId}`
}

export const mobileMoneyPaymentUrl = (
    clientCode?: string,
    villageId?: string
) => {
    return `/mobile-money/payment?client-code=${clientCode}&village-id=${villageId}`
}

export type MobilePaymentReturnStatus = 'success' | 'failure'

/**
 * Build the URL a mobile-money provider should redirect back to.
 *
 * Appends `mobile-payment` and `mm-amount` as proper query parameters, whether
 * or not `href` already has a query string, and replaces any existing values so
 * repeated attempts never stack parameters onto the path or each other.
 */
export const buildMobilePaymentReturnUrl = (
    href: string,
    status: MobilePaymentReturnStatus,
    amount: number
) => {
    const url = new URL(href)
    url.searchParams.set('mobile-payment', status)
    url.searchParams.set('mm-amount', String(amount))
    return url.toString()
}

export const ENROLLMENT_QR_SOURCE = 'connect_qr'

export const buildEnrollmentQrUrl = (villageCode?: string): string | null => {
    const baseUrl = process.env.REACT_APP_FARMER_APP_URL?.replace(/\/+$/, '')
    if (!baseUrl || !villageCode) return null

    return `${baseUrl}/enroll/?v=${encodeURIComponent(
        villageCode
    )}&source=${ENROLLMENT_QR_SOURCE}`
}
